import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { SeoConfigBuilder } from '@/lib/seo/SeoVariables';
import { WishListView } from '@/views/WishListView';
export const getServerSideProps: GetServerSideProps = getFixedPageStaticProps(
  'my-account/my-wishlist',
  new SeoConfigBuilder().setNoIndex().build(),
);
export default withFixedPageCommonProps(WishListView);
